var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.list && _vm.computedStations.length)?_c('button',{staticClass:"g-btn g-btn--rounded g-btn--blue selective-survey-button",attrs:{"type":"button"},on:{"click":_vm.surveyBtnClicked}},[_vm._v("\n  "+_vm._s(_vm.$t('messages.sharedTexts.stations.stationSurvey'))+" "),_c('font-awesome-icon',{attrs:{"icon":['fas', 'chevron-right']}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }